module.exports = __webpack_public_path__ + "static/media/pro2.149662b0.jpg";